import React, { useContext } from 'react';
import { CounterCard, FloatCard, MoneyCounterCard } from '../components/CounterCard';
import { useIsAwr } from '../login/AuthContext';
import { getLeadsProjection } from '../models/Account';
import { frequency } from '../models/FullReportEntry';
import { AdDetailContext } from './DetailStore';

export function AdsDetailSummaryHeader(){
    const {state} = useContext(AdDetailContext);
    const isAwr = useIsAwr();

    return  <div className='counter-cards counter-cards-lighter'>
            <CounterCard title='Leads' count={state.report.report.nLeads} />
            {state.period == null && <CounterCard title="Projeção de Leads" count={getLeadsProjection(state.report.report.nLeads)} />}
            <CounterCard title="Alcance" count={state.report.report.reach} />
            <FloatCard title="Frequência" value={frequency(state.report.report)} />
            {!isAwr && <MoneyCounterCard title='Custo por lead' count={state.report.report.totalCost / state.report.report.nLeads} />}
            {/*state.report.report.info?.filteredCampaigns == null*/ true && <MoneyCounterCard title='Investimento' count={state.report.report.totalCost} />}
            {/*state.report.report.info?.filteredCampaigns != null*/ false && <>
                <MoneyCounterCard title='Investimento Engajamento' count={state.report.report.totalCost} />
                <MoneyCounterCard title='Investimento Tráfego' count={state.report.report.info.filteredCampaigns.cost} />
                <MoneyCounterCard title='Engajamento + Tráfego' count={state.report.report.totalCost + state.report.report.info.filteredCampaigns.cost} />
            </>}
        </div>
}